import React, { useState, useEffect } from "react";
import {
  Wrapper,
  MenuTextLink,
  MenuWrapper,
  MenuSocialButton,
  MenuButton,
} from "./index.styled";
import { useHeaderColor } from "context";
import { useStaticQuery, graphql } from "gatsby";
import { CSSTransition } from "react-transition-group";
import Menu from "./menu";

const OPTIONS_API_PATH = "/wp-json/hines/v2/options";

const Header = ({ className }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [socialLinks, setSocialLinks] = useState([]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const data = useStaticQuery(graphql`
    query HeaderQuery {
      menuContent {
        content {
          copyright
          legalLinks {
            text
            url
          }
          mainList {
            subItems {
              text
              url
              anchor
              divider
            }
            text
            url
          }
          secondList {
            url
            text
          }
          socialLinks {
            link
            text
            url
          }
        }
        headerLogo {
          url
          alt
          title
          width
          height
        }
      }
    }
  `);
  const { headerState } = useHeaderColor();
  const content = data.menuContent.content[0];
  const headerLogo = data.menuContent.headerLogo;

  useEffect(() => {
    const fetchOptions = async () => {
      const baseUrl = process.env.GATSBY_PUBLIC_WP_API;
      if (!baseUrl) return;
      try {
        const response = await fetch(`${baseUrl}${OPTIONS_API_PATH}`);
        const json = await response.json();
        if (json?.success && json?.menus?.[0]?.socialLinks?.length) {
          setSocialLinks(json.menus[0].socialLinks);
        }
      } catch (err) {
        console.error("Header: failed to fetch options", err);
      }
    };
    fetchOptions();
  }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.callrail.com/companies/947260113/961782180f55d57a93d1/12/swap.js";
    script.id = "callrail-js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      const existingScript = document.getElementById("callrail-js");
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);

  // useEffect(() => {
  //   const script = document.createElement('script');
  //   script.src = "https://app.trypath.io/ai-tour-widget.js";
  //   script.setAttribute('show-agent-image', 'false');
  //   script.setAttribute('backend-api-endpoint', 'https://path-intelligence-793200f813cb.herokuapp.com/api/v1');
  //   script.setAttribute('frontend-api-endpoint', 'https://app.trypath.io');
  //   script.setAttribute('property-uuid', '3f203e8c-ec87-416e-adfd-cc9f0c4be01a');
  //   script.setAttribute('logo-file', 'logo-path-white-no-word.png');
  //   script.setAttribute('logo-full-file', 'path-logo-white-full.png');
  //   script.setAttribute('widget-position', 'bottom-left');
  //   script.async = true;
  //   document.body.appendChild(script);
  //   return () => {
  //     document.body.removeChild(script);
  //   };
  // }, []);

  const linksToRender = socialLinks.length > 0
    ? socialLinks
    : (content?.socialLinks ?? []).map((s) => ({
        text: s.text,
        url: s.url ?? s.link ?? "#",
        target: "_self",
      }));

  return (
    <>
      <Wrapper className={className} $state={headerState}>
        <div></div>
        <MenuWrapper>
          {linksToRender.map((item, index) => {
            const url = item.url ?? "#";
            const isInternal = url.startsWith("/");
            const target = item.target === "_blank" ? "_blank" : "_self";
            const rel = target === "_blank" ? "noopener noreferrer" : undefined;

            if (isInternal) {
              return (
                <MenuTextLink
                  key={`header-social-${index}`}
                  to={url}
                  target={target}
                  rel={rel}
                >
                  {item.text?.toUpperCase() ?? "LINK"}
                </MenuTextLink>
              );
            }
            return (
              <MenuSocialButton
                key={`header-social-${index}`}
                href={url}
                target={target}
                rel={rel}
                aria-label={item.text ?? "Social link"}
              />
            );
          })}
          <MenuButton onClick={toggleMenu} aria-label="Open menu" />
        </MenuWrapper>
        <CSSTransition
          in={isOpen}
          timeout={300}
          classNames="menu"
          unmountOnExit
        >
          <Menu data={content} headerLogo={headerLogo} onClick={toggleMenu} />
        </CSSTransition>
      </Wrapper>
    </>
  );
};

export default Header;
